import CountryModalInMobile from '@/components/ui/CountryModalInMobile';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import Cookies from 'js-cookie';
import CountryPickerModal from '@/components/ui/CountryPickerModal';
interface PassModalProps {
    showPassModal: boolean;
    setRoomData: Dispatch<SetStateAction<{ adults: number; children: number[] }[]>>;
    roomData: { adults: number; children: number[] }[];
}

export default function PassengerModal({ showPassModal, setRoomData, roomData }: PassModalProps) {
    const handleReduceChildren = (index: number) => {
        setRoomData((prevRoomData) => {
            const updatedRoomData = [...prevRoomData]; // Create a copy of the roomData array
            const children = [...updatedRoomData[index].children]; // Create a copy of the children array for the specific index
            if (children.length > 0) {
                children.pop(); // Reduce the children array by one item
            }
            updatedRoomData[index] = { ...updatedRoomData[index], children }; // Update the children array in the specific index
            return updatedRoomData; // Return the updated roomData array
        });
    };

    const handleAddChildren = (index: number) => {
        setRoomData((prevRoomData) => {
            const updatedRoomData = [...prevRoomData];
    
            if (updatedRoomData[index].children.length >= 10) {
                return prevRoomData;
            }
    
            const children = [...updatedRoomData[index].children, 2]; 
            updatedRoomData[index] = { ...updatedRoomData[index], children };
    
            return updatedRoomData;
        });
    };


    const handleChangeChildNumber = (
        roomIndex: number,
        childIndex: number,
        newNumber: number,
    ) => {
        setRoomData((prevRoomData) => {
            const updatedRoomData = [...prevRoomData]; // Create a copy of the roomData array
            const children = [...updatedRoomData[roomIndex].children]; // Create a copy of the children array for the specific room index
            children[childIndex] = newNumber; // Update the child number at the specified index
            updatedRoomData[roomIndex] = { ...updatedRoomData[roomIndex], children }; // Update the children array in the specific room index
            return updatedRoomData; // Return the updated roomData array
        });
    };

    
    const handleAddOneAdult = (index: number) => {
        setRoomData((prevRoomData) => {
            const updatedRoomData = [...prevRoomData];
    
            if (updatedRoomData[index].adults >= 10) {
                return prevRoomData;
            }
    
            updatedRoomData[index] = {
                ...updatedRoomData[index],
                adults: updatedRoomData[index].adults + 1,
            };
    
            return updatedRoomData;
        });
    };

    const handleReduceOneAdult = (index: number) => {
        setRoomData((prevRoomData) => {
            const updatedRoomData = [...prevRoomData]; // Create a copy of the roomData array
            const currentAdults = updatedRoomData[index].adults;
            if (currentAdults > 1) {
                updatedRoomData[index] = {
                    ...updatedRoomData[index],
                    adults: currentAdults - 1,
                }; // Reduce one unit from adults for the specific index
            }
            return updatedRoomData; // Return the updated roomData array
        });
    };



    return (
        <div className={`${showPassModal ? "z-20 opacity-100 " : " z-0 !h-0 overflow-hidden opacity-0 lg:translate-y-[96%]"}
         z-10 flex h-fit w-full min-w-fit flex-col overflow-hidden duration-300
           lg:w-80   lg:bg-white lg:p-3  lg:transition-all`} >
            <div className="h-fit  overflow-y-auto no-scroller 
                             scroll pr-1">
                {roomData.map((room, index) => (
                    <div key={index} className="rounded-3xl p-4 bg-white shadow-sm mb-4">
                        <div className="flex items-center justify-between pb-4">
                            <h3 className="text-sm font-medium text-neutral-600">Room {index + 1}</h3>
                            {index !== 0 && <button
                                type="button"
                                className=" text-xs  font-medium  text-rose-500"
                                onClick={() => {
                                    let newArray = roomData;
                                    newArray.splice(index, 1);

                                    setRoomData([...newArray]);
                                }}
                            >
                                Delete Room
                            </button>}
                        </div>
                        <div className="mt-2 flex items-center justify-between">
                            <div className="font-normal">
                                <p className="text-sm font-semibold text-neutral-800">Adults</p>
                                <p className="text-xs text-neutral-500 font-normal">18 and older</p>
                            </div>
                            <div className="flex max-w-[115px] grow items-center justify-between border border-neutral-100 rounded-2xl p-2">
                                <button onClick={() => handleReduceOneAdult(index)} type="button" className={`${room.adults <= 1 ? 'bg-neutral-400' : 'bg-secondary-500'} aspect-square rounded-xl w-8 text-lg border text-white px-2`} >
                                    -
                                </button>
                                <span className="">{room.adults}</span>
                                <button onClick={() => handleAddOneAdult(index)} type="button" className="aspect-square rounded-xl w-8 text-lg border bg-secondary-500 text-white px-2" >
                                    +
                                </button>
                            </div>
                        </div>
                        <div className="mt-4 flex items-center justify-between">
                            <div className="font-normal">
                                <p className="text-sm font-semibold text-neutral-800">Children</p>
                                <p className="text-xs text-slate-500">Age 2 through 17</p>
                            </div>
                            <div className="flex max-w-[115px] grow items-center justify-between border border-neutral-100 rounded-2xl p-2">
                                <button type="button" onClick={() => handleReduceChildren(index)} className={`${room.children.length === 0 ? 'bg-neutral-400' : 'bg-secondary-500'} aspect-square rounded-xl w-8 text-lg border text-white px-2`}>
                                    -
                                </button>
                                <span className="">{room.children.length}</span>
                                <button type="button" onClick={() => handleAddChildren(index)} className="aspect-square rounded-xl w-8 text-lg border bg-secondary-500 text-white px-2" >
                                    +
                                </button>
                            </div>
                        </div>
                        {room.children.length > 0 && (
                            <div className="mt-3 grid grid-cols-2 gap-3 border-t pt-3">
                                {room.children.map((child, childIndex) => (
                                    <div key={childIndex}>
                                        <h4 className="mb-1 text-xs text-gray-500">
                                            Child {childIndex + 1} age
                                        </h4>
                                        <select
                                            onChange={(e) =>
                                                handleChangeChildNumber(
                                                    index,
                                                    childIndex,
                                                    Number(e.target.value),
                                                )
                                            }
                                            className="w-full rounded-md border bg-slate-100 p-1"
                                            value={child}
                                        >
                                            <option value={2}>2</option>
                                            <option value={3}>3</option>
                                            <option value={4}>4</option>
                                            <option value={5}>5</option>
                                            <option value={6}>6</option>
                                            <option value={7}>7</option>
                                            <option value={8}>8</option>
                                            <option value={9}>9</option>
                                            <option value={10}>10</option>
                                            <option value={11}>11</option>
                                            <option value={12}>12</option>
                                            <option value={13}>13</option>
                                            <option value={14}>14</option>
                                            <option value={15}>15</option>
                                            <option value={16}>16</option>
                                            <option value={17}>17</option>
                                        </select>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}

            </div>
            <button type="button" onClick={() => setRoomData([...roomData, { adults: 1, children: [] }])}
                className="w-full text-center cursor-pointer text-sm font-medium text-secondary-500 " >
                + Add another room
            </button>
        </div>
    );
};